﻿/* globals fbq, FacebookDTO*/
import jquery from 'jquery';
import HabEvents from '../../Global/habitaclia-events';

export default class FacebookTracking {

	constructor(FacebookDTO) {
      this.FacebookDTO = FacebookDTO;
			this.registerEvents();
	}

	registerEvents() {
		if (window.fbq)
		{
			jquery.subscribe(HabEvents.EventsEnum.ConfirmacionSolicitudEnviada, () => {
				window.fbq('track', 'InitiateCheckout');
				window.fbq('track', 'Purchase', {
					content_type: 'product',
					content_ids: [this.FacebookDTO.IdProduct],
					value: 1,
					currency: 'EUR',
					product_catalog_id: '311743049534061',
				} );
			});
		}
		
	}
}

/* jshint unused: false */
if(window.FacebookDTO){
    const facebookInstance = new FacebookTracking(FacebookDTO);
} else {
    window.FacebookTracking = FacebookTracking;
}